// extracted by mini-css-extract-plugin
export default {"header":"resignation-form-modal_header__xDM58","title":"resignation-form-modal_title__oBrTp","body":"resignation-form-modal_body__52vCe"};